import script from "./InventoryForecasting.vue?vue&type=script&setup=true&lang=js"
export * from "./InventoryForecasting.vue?vue&type=script&setup=true&lang=js"

import "./InventoryForecasting.vue?vue&type=style&index=0&id=aecf963e&lang=css"

const __exports__ = script;

export default __exports__